import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';
import * as actionCreators from '../../store/actions/index';

//import classes from './WizardButton.css';

const wizardNavigationButton = (props) => {

  const status = props.status || '';
  const dispatch = useDispatch();

  const unsetStepAction = useCallback(
      () => dispatch(actionCreators.wizardUnsetStep(props.stepType)),
      [dispatch]
    )

  const { t } = useTranslation();

  const text_selected_value = (stepType, selectedValue) => (stepType === "medium_type")? t('wizard.navigation.medium_type.label') : t('wizard.steps.'+stepType+'.values.' + selectedValue + "." + props.i18nTokenType)

  const styleDisabledSelected = {
    fontSize: "1.0rem",
    fontWeight: "500",
    margin: "0 10px 10px 0",
    color: "#222629",
    backgroundColor: "#E2E6EA",
    pointerEvents: "none",
  }

  const styleDisabledNotSelected = {
    fontSize: "1.0rem",
    fontWeight: "500",
    margin: "0 10px 10px 0",
    color: "#212529",
    backgroundColor: "#fff",
    pointerEvents: "none",
    borderColor: "#ccc"
  }

  if (props.disabledNavigation === true) {
    switch (status) {
      case 'selected':
        return <button
          type="button"
          style={styleDisabledSelected}
          className={"btn"}
          >{ text_selected_value(props.stepType, props.selectedValue) }</button>
      case 'active':
        return <button
          type="button"
          className={"btn"}
          style={styleDisabledSelected}
          >{ t('wizard.steps.'+props.stepType+'.values.' + props.selectedValue + "." + props.i18nTokenType) }</button>
      case 'disabled':
        return <button
          type="button"
          className={"btn"}
          style={styleDisabledNotSelected}
          disabled={true}>{ t('wizard.navigation.'+props.stepType+'.label') }</button>
      default: return null;
    }
  } else {
    switch (status) {
      case 'selected':
        return <button
          type="button"
          onClick={unsetStepAction}
          className={"btn btn-light wizzard-steps-selected"}>{ text_selected_value(props.stepType, props.selectedValue) } </button>
      case 'active':
        return <button
          type="button"
          className={"btn wizzard-nav-btn wizzard-steps-active"}
          disabled={true}>{ t('wizard.navigation.'+props.stepType+'.label') }</button>
      case 'disabled':
        return <button
          type="button"
          className={"btn wizzard-nav-btn wizzard-steps"}
          disabled={true}>{ t('wizard.navigation.'+props.stepType+'.label') }</button>
      default: return null;
    }
  }


};

export default wizardNavigationButton;



// WEBPACK FOOTER //
// ./src/components/Wizard/WizardNavigationButton.js